export default {
    totalQurban: 0,
    qurbans: [],
    otherQurbans: [],
    transactionProduct: null,
    transactionPayment: null,
    transactionHistory: null,
    track: {
        kode: null,
        data: null
    }
}